import { InternalAccount, InternalNpsPeriod } from 'types/GlobalInternalAccount'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/internal/accounts`

export async function getAll() {
  return getWithRedirect<InternalAccount[]>(URL)
}

export async function getOne(id: string) {
  return getWithRedirect<InternalAccount>(`${URL}/${id}`)
}

export async function getNps(id: string) {
  return getWithRedirect<InternalNpsPeriod[]>(`${URL}/${id}/nps`)
}
